import { useQuery } from "react-query";
import { Loader } from "$components/Layout/Loader";
import { EntrepotService } from "$services";
import { Text } from "$components";
import { CacheInvalidationAction } from "$utils/cache";

type Props = {
  id: string;
};

export const RenderWarehouse = ({ id }: Props) => {
  const { data: warehouse, isLoading } = useQuery(
    [CacheInvalidationAction.GET_ENTREPOT_BY_ID, id],
    () => EntrepotService.getEntrepotById(id),
    {
      enabled: !!id,
      staleTime: 60 * 1000,
    }
  );
  if (isLoading) {
    return <Loader />;
  }
  return (
    <Text
      type="h3"
      style={{
        fontWeight: "bold",
      }}
    >
      {warehouse?.name}
    </Text>
  );
};
